import { render, staticRenderFns } from "./description-modal.vue?vue&type=template&id=bfaa94e2&scoped=true&"
import script from "./description-modal.vue?vue&type=script&lang=js&"
export * from "./description-modal.vue?vue&type=script&lang=js&"
import style0 from "./description-modal.vue?vue&type=style&index=0&id=bfaa94e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfaa94e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfaa94e2')) {
      api.createRecord('bfaa94e2', component.options)
    } else {
      api.reload('bfaa94e2', component.options)
    }
    module.hot.accept("./description-modal.vue?vue&type=template&id=bfaa94e2&scoped=true&", function () {
      api.rerender('bfaa94e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/functions/function/indicators/components/description-modal.vue"
export default component.exports